import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NationsComponent } from './nations.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [NationsComponent],
  exports:[NationsComponent],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class NationsModule { }
